import { useCallback, useEffect, useState } from 'react';

export const useMobileView = () => {

  /**
   * STATE: isMobileNavVisible
   * Controls whether channel list is visible on mobile
   * INITIAL VALUE: true (show channel list by default)
   * WHY TRUE:
   * After code changes for default screen open to channel list,
   * click functionality stopped working first time because default value was false.
   * Clicking on channel would toggle the value to true and trigger unnecessary re-renders.
   * (Note: The actual show/hide logic is in CSS classes)
   * STATES:
   * - true: Channel list visible (chat hidden on mobile)
   * - false: Chat visible (channel list hidden on mobile)
   */
  const [isMobileNavVisible, setIsMobileNavVisible] = useState(true);

  /**
   * EFFECT: Update DOM classes and body overflow
   * Runs whenever isMobileNavVisible changes
   */
  useEffect(() => {
    const mobileChannelList = document.querySelector('#mobile-channel-list');
    
    if (isMobileNavVisible && mobileChannelList) {
      // Show channel list, hide chat
      mobileChannelList.classList.add('show');
      document.body.style.overflow = 'hidden';
    } else if (!isMobileNavVisible && mobileChannelList) {
      // Show chat, hide channel list
      mobileChannelList.classList.remove('show');
      document.body.style.overflow = 'auto';
    }
    else {
      // Fallback: element not found yet
      document.body.style.overflow = 'hidden';
    }

  }, [isMobileNavVisible]);

  /**
   * RETURN: Toggle function
   * Returns memoized callback that toggles isMobileNavVisible state
   * MEMOIZATION:
   * useCallback ensures same function reference across re-renders
   * Prevents unnecessary re-renders of components using this hook
   */
  return useCallback(() => {
    setIsMobileNavVisible((isMobile) => !isMobile);
  }, []);
};
